import {ErrorsFromApi} from '@myxplor/ui'

import {fetchWithRetry} from '../authorisation'
import {process as processDetails} from '../gov-care-registration-details'
import {process as processPersonnel} from '../auth-personnel'
import {
  REGISTRATION_PROCESSING,
  REGISTRATION_FAILED,
  REGISTRATION_SUCCESSFUL
} from './constants'

export const successful = (response, dispatch) => {

  // We are dispatching events to other reducers
  // as this payload is very large
  const {
    attributes
  } = response.data

  dispatch(processDetails({
    address: attributes.address,
    capacity: attributes.places,
    operational_profile: attributes['operational-profile'],
  }))

  dispatch(processPersonnel({
    attributes: response.included.filter(val => {
      return val.type === 'personnel'
    })
  }))

  return {
    type: REGISTRATION_SUCCESSFUL,
    attributes: {
      id: response.data.id,
      name: attributes.name,
      ccb_approval_id: attributes['ccb-approval-id'],
      abn: attributes.abn
    }
  }
}

export const processing = () => {
  return {
    type: REGISTRATION_PROCESSING
  }
}

export const failed = (response) => {
  return {
    type: REGISTRATION_FAILED,
    errors: response.errors
  }
}

export const APIFailed = (message) => {
  return {
    type: REGISTRATION_FAILED,
    errors: [],
    notification: {
      message: ErrorsFromApi(message),
      message_type: 'error'
    }
  }
}

export const apiPath = ({record_type, id}) => (
  `${process.env.REACT_APP_API_HOST}/api/${record_type}/${id}/registration`
)

export const submitSignIn = ({resourceIDs, tokens, payload: requestPayload}) => (dispatch) => {
  dispatch(processing())

  return fetchWithRetry(
    apiPath(resourceIDs),
    {
      method: 'POST',
      jsonAPI: true,
      token: tokens.jwt,
      body: {
        data: {
          type: 'service-registration',
          attributes: requestPayload
        }
      }
    }, dispatch)
    .then(response => (
      response.json()
        .then(
          payload => {
            dispatch(response.ok ?
              successful(payload, dispatch) :
              failed(payload)
            )
          }
        )
    ))
    .catch(response => {
      dispatch(
        APIFailed(response.message)
      )
    })
}



// WEBPACK FOOTER //
// ./src/registration/actions.js